import { useCreateSwagContext } from "@contexts/create-swag-context";

import CheckboxInput from "@stadium/ui/src/components/form/CheckboxInput";
import Label from "@stadium/ui/src/components/form/Label";

import styles from "./main.module.scss";

const PreferredColors = ({ onColorChange, selectedIds, checkboxInputClass = "" }) => {
  const { colorGroupsData } = useCreateSwagContext();
  return colorGroupsData.map((color) => {
    const colorId = `${color.id}`;
    const isSelected = selectedIds.includes(Number(color.id));

    return (
      <CheckboxInput
        id={colorId}
        key={colorId}
        value={color.id}
        checked={isSelected}
        onClick={() => onColorChange(Number(color.id))}
        classes={`${styles.checkboxInput} ${checkboxInputClass} ${
          isSelected ? styles.selectedColor : ""
        }`}
        label={
          <Label showIcon={false}>
            <span className={styles.colorInputLabel} style={{ backgroundColor: color.name }} />
            <span className={styles.labelValue}>{color.presentation}</span>
          </Label>
        }
      />
    );
  });
};

export default PreferredColors;
